/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
import React, { useRef, useEffect, useState } from 'react';
import { ContextMenuComponent } from '@syncfusion/ej2-react-navigations';
import { DropDownButtonComponent, ItemModel } from '@syncfusion/ej2-react-splitbuttons';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveWorkspace, setWorkspaceGroupData } from 'src/store/workspaces/workspaces/actions';
import { run as runActions } from '../../../../../store/workspaces/workspaces/run';
import { getModules } from 'src/store/workspaces/modules/actions';
import { StyledDropDownWrapper } from '../../styles';
import WorkspaceGroupDialog from '../dialog/dialog.workspace';
import { goHome } from 'src/components/Header/breadcrumb/services/goHome';
import { defaultWorkspace } from '../../settings/settings';
import ConfirmDeleteDialog from '../dialog/dialog.workspace.delete';
import { WorkspaceService } from 'src/api/services/workspaces/Service.workspace';
import { setTabEnabled } from '../utils/enableTab';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Workspaces = ({ activeWsId, onActiveChange }) => {
  const contextMenuRef = useRef<any>(null);
  const dropdownRef = useRef<any>(null);
  const [selectedGroup, setSelectedGroup] = useState<any>(null);
  const [ready, setReady] = useState(false);
  const [showGroupDialog, setShowGroupDialog] = useState(false);
  const workspaces = useSelector((state: any) => state.workspaces);
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
  const dispatch = useDispatch<any>();
  const workspaceService = new WorkspaceService();

  useEffect(() => {
    const t = setTimeout(() => setReady(true), 0);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (dropdownRef.current?.element) {
      const btnEl = dropdownRef.current.element as HTMLElement;
      const text = btnEl.innerText.trim();
      btnEl.setAttribute('title', text);
    }
  });

  const onMenuClick = async ({ item: { id } }: any) => {
    if (id === 'change') return setShowGroupDialog(true);
    if (id === 'delete') return setConfirmDeleteVisible(true);
  };

  const onClick = async (uuid: string) => {
    onActiveChange(uuid);
    const res = await workspaceService.getAll();
    const group = res.find((g) => g.uuid === uuid);
    if (!group) return;

    localStorage.setItem('activeWorkspace', JSON.stringify(group));
    const response = await workspaceService.getTabs(group.uuid);

    if (response?.data.length === 0) {
      await dispatch(setWorkspaceGroupData([defaultWorkspace]));
      await goHome();
      await dispatch(getModules());
      return;
    }

    await response?.data?.forEach((e) => setTabEnabled(e, null, true));

    await dispatch(setWorkspaceGroupData(response?.data));
    await dispatch(setActiveWorkspace(0));
    await runActions(response.data[0].data.key, response.data[0].data.id, response.data[0].data);
    // await dispatch(setIsNewWorkspace(0, false));
    // await dispatch(getModules());
  };

  const onContextMenu = (e: React.MouseEvent, group: any) => {
    e.preventDefault();
    setSelectedGroup(group);
    if (ready && contextMenuRef.current && e.target instanceof HTMLElement) contextMenuRef.current.open(e.pageY, e.pageX, e.target);
  };

  const beforeItemRender = (args) => {
    const group = workspaces.groups.find((g: any) => g.uuid === args.item.id);
    if (group) {
      const iconEl = args.element.querySelector('.e-menu-icon, .e-icon');
      if (iconEl) iconEl.style.color = group.color || '#000';
      args.element.style.color = group.color || '#000';
      args.element.addEventListener('contextmenu', (e) => onContextMenu(e as any, group));

      if (group.locked) {
        const icon = args.element.querySelector('.e-menu-icon, .e-icon');
        const text = args.item.text;
        args.element.textContent = '';

        if (icon) {
          args.element.appendChild(icon);
          icon.style.marginRight = '6px';
          icon.style.color = group.color || '#000';
        }

        const nameSpan = document.createElement('span');
        nameSpan.textContent = text;
        nameSpan.style.marginLeft = '5px';
        const lockedSpan = document.createElement('span');
        lockedSpan.textContent = ' (locked)';
        lockedSpan.style.fontSize = '0.75em';
        lockedSpan.style.color = '#787878'; 
        lockedSpan.style.marginLeft = '4px';
        lockedSpan.style.letterSpacing = '-0.5px';
        args.element.appendChild(nameSpan);
        args.element.appendChild(lockedSpan);
      }
    }
  };

  const activeGroup = JSON.parse(localStorage.getItem('activeWorkspace') || '{}');
  const bgColor = activeGroup?.color || '#C9B27C';
  const dropdownItems: ItemModel[] = workspaces.groups.filter((g: any) => g.uuid !== JSON.parse(localStorage.getItem('activeWorkspace') || '{}')?.uuid).map((g: any) => ({ text: g.name, id: g.uuid, iconCss: `e-icons e-${g.icon}` }));

  return (
    <>
      {ready && (
        <ContextMenuComponent
          id="ws-contextmenu"
          ref={contextMenuRef}
          target="#workspace-dropdown"
          items={[
            { text: 'Workpsace löschen', id: 'delete' },
            { text: 'Workpsace verwalten', id: 'change' }
          ]}
          select={onMenuClick}
        />
      )}

      <StyledDropDownWrapper bgColor={bgColor}>
        <DropDownButtonComponent
          id="workspace-dropdown"
          ref={dropdownRef}
          items={dropdownItems}
          iconCss={activeGroup?.icon ? `e-icons e-${activeGroup.icon}` : undefined}
          content={activeGroup?.name || 'Gruppe wählen'}
          select={(args) => onClick(args.item.id)}
          beforeItemRender={(args) => beforeItemRender(args)}
          disabled={workspaces.groups.length <= 1}
        />
      </StyledDropDownWrapper>

      {showGroupDialog && (
        <WorkspaceGroupDialog
          visible={showGroupDialog}
          onClose={() => {
            setShowGroupDialog(false);
            setSelectedGroup(null);
          }}
          selectedGroup={selectedGroup}
        />
      )}

      {confirmDeleteVisible && (
        <ConfirmDeleteDialog
          visible={confirmDeleteVisible}
          onClose={() => {
            setShowGroupDialog(false);
            setConfirmDeleteVisible(false);
            setSelectedGroup(null);
          }}
          selectedGroup={selectedGroup}
        />
      )}
    </>
  );
};

export default Workspaces;
